// Sponsor Offers -- iteration 086

export const OFFER_TARGETS = ["school", "school_and_public", "public_only"] as const;
export type OfferTarget = (typeof OFFER_TARGETS)[number];

export const OFFER_CLAIM_STATUSES = ["submitted", "contacted", "converted", "rejected"] as const;
export type OfferClaimStatus = (typeof OFFER_CLAIM_STATUSES)[number];

export const DISCOUNT_TYPES = ["percentage", "fixed", "freeform"] as const;
export type DiscountType = (typeof DISCOUNT_TYPES)[number];

export interface SponsorOfferPublic {
  id: string;
  sponsor_id: string;
  sponsor_name: string;
  sponsor_image_url: string | null;
  title: string;
  description: string;
  discount_type: DiscountType;
  discount_value: string | null;
  offer_code: string | null;
  target: OfferTarget;
  active: boolean;
  starts_at: string | null;
  ends_at: string | null;
  image_url: string | null;
  call_to_action_label: string;
  external_url: string | null;
  created_at: string;
  updated_at: string;
  _actions: { can_edit: boolean; can_claim: boolean };
}

export interface SponsorOfferListResponse {
  offers: SponsorOfferPublic[];
  _actions: { can_create: boolean };
}

export interface SponsorOfferClaimPublic {
  id: string;
  offer_id: string;
  user_id: string | null;
  school_id: string | null;
  contact_name: string;
  contact_email: string;
  contact_phone: string | null;
  notes: string | null;
  preferred_contact_time: string | null;
  status: OfferClaimStatus;
  submitted_at: string;
  updated_at: string;
}
